export const defaultFont =
  "'Graphik', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto'," +
  "'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;";
export const codeFont = "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;";
